<script>
import baseMixin from '@/mixins/baseMixin'

import BookingCardListSkeletonLoader from '@/components/skeleton/booking-card-list-skeleton-loader.vue'
import BookingCard from '../booking-card.vue'

export default {
  name: 'BookingSummaryCardList',
  components: { BookingCardListSkeletonLoader, BookingCard },
  mixins: [baseMixin],
  props: {
    loadingCount: {
      type: Number,
      default: 0,
    },
    bookings: {
      type: Array,
      default: () => [],
    },
    expandAll: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      accordion: [],
    }
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0
    },
  },
  watch: {
    expandAll() {
      this.determinePanelExpandState()
    },
    loadingCount() {
      if (!this.expandAll) {
        // Open first accordion
        this.accordion.push(0)
      } else {
        this.determinePanelExpandState()
      }
    },
  },
  methods: {
    determinePanelExpandState() {
      this.accordion = this.expandAll
        ? [...Array(this.bookings.length).keys()].map((k, i) => i)
        : []
    },
    viewCandidate(value) {
      this.$emit('viewCandidate', value)
    },
    cancelBooking(value) {
      this.$emit('cancelBooking', value)
    },
  },
}
</script>

<template>
  <v-expansion-panels
    v-if="!isLoading"
    v-model="accordion"
    accordion
    flat
    multiple
    hover
  >
    <v-expansion-panel
      v-for="client of bookings"
      :key="client.clientId"
      class="transparent"
    >
      <v-expansion-panel-header>{{
        client.clientName
      }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <div
          v-for="location in client.locations"
          :key="`booking-summary-card__location-${location.locationId}`"
        >
          <p class="subtitle-2 font-weight-medium mt-4 mb-8">
            {{ location.locationName }}
          </p>

          <BookingCard
            v-for="booking in location.bookings"
            :key="`bookingcard_${booking.id}`"
            :booking="booking"
            @viewCandidate="viewCandidate"
            @cancelBooking="cancelBooking"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  <BookingCardListSkeletonLoader v-else :count="loadingCount" />
</template>
